export const navigationMock = [
  {
    label: 'Visit',
    url: '/visit/',
    items: [
      {
        label: 'Opening Hours',
        url: '/visit/opening-hours/',
      },
      {
        label: 'Prices',
        url: '/visit/prices/',
      },
      {
        label: 'Facilities',
        url: '/visit/facilities/',
      },
      {
        label: 'Location & Parking',
        url: '/visit/location-and-parking/',
      },
      {
        label: 'Tram Information',
        url: '/visit/tram-information/',
      },
      {
        label: 'Accessibility',
        url: '/visit/accessibility/',
      },
      {
        label: 'Map',
        url: '/visit/map/',
      },
      {
        label: 'Cafe',
        url: '/visit/cafe/',
      },
      {
        label: 'Shop',
        url: '/visit/shop/',
      },
    ],
  },
  {
    label: "What's On",
    url: '/whats-on/',
    items: [
      {
        label: 'Events',
        url: '/events/',
      },
      {
        label: 'Exhibitions',
        url: '/exhibitions/',
      },
      {
        label: 'Experiences',
        url: '/experiences/',
      },
    ],
  },
  {
    label: 'Learning',
    url: '/learning/',
    items: [
      {
        label: 'After School Clubs',
        url: '/learning/after-school-clubs/',
      },
      {
        label: 'Kete & Programmes',
        url: '/learning/programmes/',
      },
      {
        label: 'Booking Information',
        url: '/learning/booking-information/',
      },
      {
        label: 'STEAM Cells',
        url: '/learning/steam-cells/',
      },
      {
        label: 'Learnables',
        url: '/learning/learnables/',
      },
      {
        label: 'Online Workshops',
        url: '/learning/online-workshops/',
      },
    ],
  },
  {
    label: 'Collection & Stories',
    url: '/collections-and-stories/',
    items: [
      {
        label: 'Collections Online',
        url: 'https://collection.motat.nz/',
      },
      {
        label: 'Walsh Memorial Library',
        url: '/collections-and-stories/walsh-memorial-library/',
      },
      {
        label: 'Stories',
        url: '/collections-and-stories/stories/',
      },
      {
        label: 'Collection Offer',
        url: '/collections-and-stories/collection-offer/',
      },
    ],
  },
  {
    label: 'Support & Join',
    url: '/support-and-join/',
    items: [
      {
        label: 'Donations',
        url: '/support-and-join/donate/',
      },
      {
        label: 'Partnerships',
        url: '/support-and-join/partnerships/',
      },
      {
        label: 'Bequests',
        url: '/support-and-join/bequests/',
      },
      {
        label: 'Employment',
        url: '/support-and-join/employment/',
      },
      {
        label: 'Volunteer',
        url: '/support-and-join/volunteer/',
      },
    ],
  },
]
